import {
  cloneElement,
  JSXElementConstructor,
  ReactElement,
  useRef,
} from "react";
import Modal, { Props } from "react-modal";
import { spacing } from "../../stitches.config";
import { useOutsideAlerter } from "../../utils/outsideAlerter";
import { modalOverlay } from "./__styles__/Modal";
import { ActionButton } from "./Buttons/ActionButton";

interface ModalProps extends Omit<Props, "isOpen"> {
  children: ReactElement<any, string | JSXElementConstructor<any>>;
}

export default ({
  children,
  customAppElement = "#app",
  ...modalProps
}: ModalProps & { customAppElement?: string }) => {
  Modal.setAppElement(customAppElement);

  modalOverlay();

  const wrapperRef = useRef(null as Maybe<HTMLDivElement>);

  useOutsideAlerter({
    ref: wrapperRef,
    onOutsideInteraction: () => modalProps.onRequestClose,
  });

  return (
    <div ref={wrapperRef}>
      <Modal
        className="modal-content"
        overlayClassName="modal-overlay"
        shouldFocusAfterRender={true}
        shouldCloseOnEsc={true}
        isOpen
        shouldReturnFocusAfterClose={true}
        {...modalProps}
      >
        {!!modalProps.onRequestClose && (
          <div
            style={{
              position: "absolute",
              top: spacing.m.value,
              right: spacing.l.value,
            }}
          >
            <ActionButton
              icon="x"
              size="medium"
              onClick={modalProps.onRequestClose}
              aria-label="Close modal"
              data-testid="closeModal"
            />
          </div>
        )}
        {cloneElement(children, {
          closeModal: modalProps.onRequestClose,
        })}
      </Modal>
    </div>
  );
};
